import React from "react";
import { CircularProgress, styled, TextField } from "@mui/material";
import Autocomplete from "@mui/lab/Autocomplete";

//region [[ Styles ]]

const SettingsAutocompleteView = styled(Autocomplete)(
  (props: { minwidth: number }) => ({
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.04)",
    borderRadius: "3px",
    background: "white",
    width: "100%",
    "& input, & textarea": {
      color: "#5C5C5D",
      fontSize: "11px",
      lineHeight: 1,
      fontWeight: 600,
      padding: "0 !important",
      minWidth: `${props.minwidth}px !important` || 0,
    },
    "& span": {
      margin: 0,
    },
  }),
);
//endregion [[ Styles ]]

//region [[ Props ]]

export interface SettingsAutocompleteProps {
  onChange: (value: SettingsAutoCompleteOption) => void;
  value: SettingsAutoCompleteOption;
  loading?: boolean;
  options?: SettingsAutoCompleteOption[];
  autoFocus?: boolean;
  multiple?: boolean;
  disabled?: boolean;
  onInputChange?: (
    event: React.ChangeEvent<{}>,
    value: string,
    reason: string,
  ) => void;
  minwidth?: number;
  freeSolo?: boolean;
  autoSelect?: boolean;
}

export interface SettingsAutoCompleteOption {
  name: string;
  value: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SettingsAutocomplete = ({
  options,
  value,
  onChange,
  loading,
  autoFocus,
  disabled,
  multiple,
  onInputChange,
  minwidth,
  freeSolo,
  autoSelect,
}: SettingsAutocompleteProps) => {
  return (
    <SettingsAutocompleteView
      autoSelect={autoSelect}
      className={"settings-autocomplete"}
      onChange={(event, newValue: SettingsAutoCompleteOption) => {
        onChange(newValue);
      }}
      value={value}
      options={options}
      loading={loading}
      isOptionEqualToValue={(option: SettingsAutoCompleteOption, value) => {
        return option.value === value;
      }}
      getOptionLabel={(option: SettingsAutoCompleteOption) => {
        return option.name || option.value;
      }}
      onInputChange={onInputChange}
      minwidth={minwidth}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            style: loading ? { paddingRight: 10 } : null,
            endAdornment: loading ? (
              <CircularProgress size={14} style={{maxWidth: 14}}/>
            ) : (
              params.InputProps.endAdornment
            ),
          }}
          placeholder={loading ? "Loading" : null}
          autoFocus={autoFocus}
          disabled={disabled}
          onBlur={(e) => {
            if (freeSolo)
              onChange({ name: e.target.value, value: e.target.value });
          }}
        />
      )}
      multiple={multiple}
      disabled={disabled}
      freeSolo={freeSolo}
    />
  );
};
